import { constants, mediaQueryStyles } from "@newsela/angelou";
const {
  BreakpointNames: { xs, md },
} = constants.breakpoints;
const { mediaQuery } = mediaQueryStyles;

export const fieldsetCss = {
  border: 0,
  margin: "24px 0 0",
  padding: 0,

  [mediaQuery.between(xs, md)]: {
    margin: "32px 0 0",
  },
};

export const listCss = {
  padding: 0,
};
